import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table } from 'antd';
import FooterCus from '../../Components/FooterCus';
import pdf from "../../Assets/images/pdf.png";
import RightSidebarGlobal from '../../Components/RightSidebarGlobal';
import { BASE_URL } from "../../routes/config";
import Loader from '../../Components/Loader';
import { NoticePDFFolder } from '../../routes/addresses';
import useFetchTenderNotice from '../../Hooks/API/useFetchTenderNotice';


function NoticePage() {
  const { getPageData, loading } = useFetchTenderNotice('/Wapi/noticelst');

  // const fetchdata = () => {
  //   axios.post(`${BASE_URL}/Wapi/noticelst`, {
  //     auth_key: "xxxxx",
  //   }).then(res => {
  //     if (res.status === 200) {
  //       if (res.data.suc > 0) {
  //         setPageData(res?.data?.msg);
  //       } else {
  //         setPageData([]);
  //       }
  //       setLoading(false);
  //     }
  //   });
  // };

  

  const columns = [
    {
      title: 'Name',
      dataIndex: 'subject',
      key: 'subject',
      width: '70%',
    },
    {
      title: 'Download',
      dataIndex: 'file_name',
      key: 'file_name',
      width: '30%',
      render: (document) => (
        <a href={BASE_URL + '/' + NoticePDFFolder + document} className='docDownload' target='_blank' rel="noreferrer">
          <i className="fa fa-download" aria-hidden="true"></i> Download
        </a>
      ),
    }
  ];


  return (
    <div className="wrapper">
      <div className="inner_page_Sec">
        <div className="col-sm-8 float-left left_sec searchPageTop">
          <h1>Notice</h1>
          {loading ? (
            <Loader align={'center'} gap={'middle'} size={'large'} />
          ) : (
            <Table
              columns={columns}
              dataSource={getPageData}
              scroll={{ x: 'max-content' }}
              rowKey={(record, index) => index}
            />
          )}
        </div>
        <div className="col-sm-4 float-left">
          <RightSidebarGlobal />
        </div>
      </div>
    </div>
  );
}

export default NoticePage;
